var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _g2, _path9, _path10, _path11, _path12, _g3, _path13, _path14, _g4, _path15, _path16, _path17, _path18, _path19, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAflatsheet2Pillow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102.64pt",
    height: "56.699pt",
    viewBox: "0 0 102.64 56.699",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m54.859 73.395h92.703v22.781h-92.703z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.875 78.676h3.1328v2.4961h-3.1328z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m101.65 49.246h28.734v16.754h-28.734z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m101.65 49.246h28.734v16.828h-28.734z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m123.36 56.871h28.637v16.828h-28.637z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m123.36 56.871h28.734v16.828h-28.734z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-3-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m101.65 49.246h28.734v16.828h-28.734z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m95.827 24.326 4.0352-1.8438",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 3.864,
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0.37352 29.286 0.96875 10.875",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 3.864,
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m41.339 12.053-38.562 14.984s-2.4023 0.67578-2.4023 2.4609c0 1.7891-0.0078 8.707-0.0078 8.707s-0.39062 1.5781 2.0586 2.6289l36.805 14.07 2.4062 0.91406s4.3672 1.6289 7.875-0.60938l40.598-19.414s3.9414-5.582 3.9414-6.2969c0-0.71484-2.6914-4.5312-2.6914-4.5312l-44.188-14.074h-3.9141",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m41.339 12.056-38.562 14.984s-2.4023 0.67578-2.4023 2.4609c0 1.7891-0.00781 8.707-0.00781 8.707s-0.39062 1.5781 2.0586 2.6289l36.805 14.07 2.4062 0.91406s4.3672 1.6289 7.875-0.60938l40.598-19.414s3.9414-5.582 3.9414-6.2969c0-0.71484-2.6914-4.5312-2.6914-4.5312l-44.188-14.074h-3.9141z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m41.351 11.877-38.559 14.984s-2.4023 0.67578-2.4023 2.4609c0 1.7891-0.0078 8.707-0.0078 8.707s-0.55078 1.4961 1.9023 2.5469l36.961 14.359 2.4062 0.91406s4.6016 1.6797 7.8711-0.60938l40.598-19.414s3.9453-5.7891 3.9453-6.5039-2.6953-4.5312-2.6953-4.5312l-44.184-14.074h-3.9141",
    fill: "#ddd9cd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m41.351 11.876-38.559 14.984s-2.4023 0.67578-2.4023 2.4609c0 1.7891-0.00781 8.707-0.00781 8.707s-0.55078 1.4961 1.9023 2.5469l36.961 14.359 2.4062 0.91406s4.6016 1.6797 7.8711-0.60938l40.598-19.414s3.9453-5.7891 3.9453-6.5039c0-0.71484-2.6953-4.5312-2.6953-4.5312l-44.184-14.074h-3.9141z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 3.864,
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51.653,-49.244)",
    clipPath: "url(#clip-0)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m549.3 5143.3 388.16-144.3s30.508-13.164 61.289 0.8984l476.05 217.54",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m0.37352 29.286v9.4883c0.078125 0.72656 0.82812 1.5703 2.9023 2.4648l38.82 14.746-0.0039 0.0078s3.2734 1.1172 6.3516-0.28906",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 3.864,
    strokeWidth: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m0.41252 29.486c-0.44141-1.5742 2.4102-2.4648 2.4102-2.4648l53.176-20.668s2.3438-1.2344 5.3125-0.17578l38.953 12.266s4.6641 1.7266-0.40234 4.043",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 3.864,
    strokeWidth: 0.25
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51.653,-49.244)",
    clipPath: "url(#clip-1)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m549.3 5143.3c-18.789 8.0859-26.719 15.781-28.633 22.578",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m102.22 20.166v8.9648c-0.082 0.58984-0.69531 1.3906-2.3516 2.1445l-51.637 24.527",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 3.864,
    strokeWidth: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m89.307 35.811v-8.8398l-47.461-15.691-0.50781-0.21875 6.8672-2.7031 47.969 15.668v9.1875l-6.8672 3.4023",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m89.307 35.806v-8.8398l-47.461-15.691-0.50781-0.21875 6.8672-2.7031 47.969 15.668v9.1875l-6.8672 3.4023v-0.80469",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m89.307 35.811v-8.8398l-47.461-15.691-0.50781-0.21875 6.8672-2.7031 47.969 15.668v9.1875l-6.8672 3.4023",
    fill: "#ddd9cd"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51.653,-49.244)",
    fill: "none",
    stroke: "#6b645b"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1478.3 5220.5v-91.875l-68.672-34.023v8.0469",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1409.6 5102.7v88.398l-474.61 156.91-5.0781 2.1875 68.672 27.031 479.69-156.68",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m953.48 4897.5 14.883 95.977 10.508-95.977",
    strokeMiterlimit: 3.864
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1508.5 5311.7s-24.961-44.805-81.875-85.938l-26.289 20.312s70.859 62.695 75.273 63.398c4.4531 0.7031 32.891 2.2266 32.891 2.2266z",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1508.5 5311.7s-24.961-44.805-81.875-85.938l-26.289 20.312s70.859 62.695 75.273 63.398c4.4531 0.7031 32.891 2.2266 32.891 2.2266z",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m77.487 6.9835s-2.5 4.4805-8.1914 8.5898l-2.625-2.0273s7.082-6.2734 7.5273-6.3438c0.44141-0.06641 3.2891-0.21875 3.2891-0.21875",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m99.197 14.904s-2.4961 4.4805-8.1875 8.5938l-2.6289-2.0312s7.0859-6.2695 7.5273-6.3398c0.44531-0.07031 3.2891-0.22266 3.2891-0.22266",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51.653,-49.244)",
    fill: "none",
    stroke: "#6b645b",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1508.5 5311.7s-24.961-44.805-81.875-85.938l-26.289 20.312s70.859 62.695 75.273 63.398c4.4531 0.7031 32.891 2.2266 32.891 2.2266z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.844 -7.6318)",
    fill: "none",
    stroke: "#6b645b",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1508.5 5311.7s-24.961-44.805-81.875-85.938l-26.289 20.312s70.859 62.695 75.273 63.398c4.4531 0.7031 32.891 2.2266 32.891 2.2266z",
    strokeMiterlimit: 10
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m69.437 16.338 0.91797-1.9258c0.17969-0.37891 0.45313-0.75781 0.80469-1.1094l3.5586-3.6055c0.34766-0.35156 0.76953-0.67578 1.2383-0.95312l2.3672-1.4023c0.34766-0.21094 0.37891-0.55078 0.0547-0.61328l-3.2812-0.65234-12.43-4.4688-2.5117-1.4297c-0.25-0.14062-0.73047 0.03516-0.86719 0.32031l-0.86719 1.8164c-0.17969 0.38281-0.45312 0.75781-0.80469 1.1133l-3.7383 3.7891c-0.35156 0.35156-0.76953 0.67578-1.2383 0.95312l-2.2383 1.3242c-0.35156 0.20703-0.37891 0.54688-0.0547 0.61328l2.7383 0.54688c0.17188 0.03125 0.33203 0.07812 0.48438 0.12891l12.48 4.4883c0.14844 0.05469 0.28906 0.11719 0.42188 0.19141l2.0977 1.1953c0.25 0.14062 0.73047-0.03906 0.86719-0.32031",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m69.437 16.336 0.91797-1.9258c0.17969-0.37891 0.45312-0.75781 0.80469-1.1094l3.5586-3.6055c0.34766-0.35156 0.76953-0.67578 1.2383-0.95312l2.3672-1.4023c0.34766-0.21094 0.37891-0.55078 0.05469-0.61328l-3.2812-0.65234-12.43-4.4688-2.5117-1.4297c-0.25-0.14062-0.73047 0.03516-0.86719 0.32031l-0.86719 1.8164c-0.17969 0.38281-0.45312 0.75781-0.80469 1.1133l-3.7383 3.7891c-0.35156 0.35156-0.76953 0.67578-1.2383 0.95312l-2.2383 1.3242c-0.35156 0.20703-0.37891 0.54688-0.05469 0.61328l2.7383 0.54688c0.17188 0.03125 0.33203 0.07812 0.48438 0.12891l12.48 4.4883c0.14844 0.05469 0.28906 0.11719 0.42188 0.19141l2.0977 1.1953c0.25 0.14062 0.73047-0.03906 0.86719-0.32031z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m69.437 16.336 0.91797-1.9258c0.17969-0.37891 0.45312-0.75781 0.80469-1.1094l3.5586-3.6055c0.34766-0.35156 0.76953-0.67578 1.2383-0.95312l2.3672-1.4023c0.34766-0.21094 0.37891-0.55078 0.05469-0.61328l-3.2812-0.65234-12.43-4.4688-2.5117-1.4297c-0.25-0.14062-0.73047 0.03516-0.86719 0.32031l-0.86719 1.8164c-0.17969 0.38281-0.45312 0.75781-0.80469 1.1133l-3.7383 3.7891c-0.35156 0.35156-0.76953 0.67578-1.2383 0.95312l-2.2383 1.3242c-0.35156 0.20703-0.37891 0.54688-0.05469 0.61328l2.7383 0.54688c0.17188 0.03125 0.33203 0.07812 0.48438 0.12891l12.48 4.4883c0.14844 0.05469 0.28906 0.11719 0.42188 0.19141l2.0977 1.1953c0.25 0.14062 0.73047-0.03906 0.86719-0.32031z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m91.137 23.92 0.92188-1.9219c0.17969-0.38281 0.45312-0.75781 0.80078-1.1133l3.5586-3.6016c0.35156-0.35547 0.76953-0.67969 1.2422-0.95703l2.3672-1.4023c0.34766-0.20703 0.37891-0.54688 0.0508-0.61328l-3.2773-0.65234v0.0039l-12.434-4.4688h4e-3l-2.5117-1.4297c-0.25-0.14453-0.73047 0.03516-0.86719 0.32031l-0.86719 1.8164c-0.18359 0.38281-0.45312 0.75781-0.80469 1.1133l-3.7383 3.7852c-0.35156 0.35547-0.76953 0.67969-1.2383 0.95703l-2.2383 1.3242c-0.35156 0.20703-0.37891 0.54688-0.0547 0.61328l2.7383 0.54297c0.17188 0.03516 0.33203 0.07813 0.48438 0.13281l12.477 4.4844c0.15234 0.05469 0.29297 0.12109 0.42578 0.19531l2.0977 1.1914c0.25 0.14453 0.73047-0.03516 0.86328-0.32031",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m91.137 23.916 0.92188-1.9219c0.17969-0.38281 0.45312-0.75781 0.80078-1.1133l3.5586-3.6016c0.35156-0.35547 0.76953-0.67969 1.2422-0.95703l2.3672-1.4023c0.34766-0.20703 0.37891-0.54688 0.0508-0.61328l-3.2773-0.65234v0.0039l-12.434-4.4688h0.0039l-2.5117-1.4297c-0.25-0.14453-0.73047 0.03515-0.86719 0.32031l-0.86719 1.8164c-0.18359 0.38281-0.45312 0.75781-0.80469 1.1133l-3.7383 3.7852c-0.35156 0.35547-0.76953 0.67969-1.2383 0.95703l-2.2383 1.3242c-0.35156 0.20703-0.37891 0.54688-0.05469 0.61328l2.7383 0.54297c0.17188 0.03515 0.33203 0.07812 0.48438 0.13281l12.477 4.4844c0.15234 0.05468 0.29297 0.12109 0.42578 0.19531l2.0977 1.1914c0.25 0.14453 0.73047-0.03516 0.86328-0.32031z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51.653,-49.244)",
    clipPath: "url(#clip-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m121.09 65.582 0.91797-1.9258c0.17969-0.37891 0.45313-0.75781 0.80469-1.1094l3.5586-3.6055c0.34766-0.35156 0.76953-0.67578 1.2383-0.95312l2.3672-1.4023c0.34766-0.21094 0.37891-0.55078 0.0547-0.61328l-3.2812-0.65234-12.43-4.4688-2.5117-1.4297c-0.25-0.14062-0.73047 0.03516-0.86719 0.32031l-0.86719 1.8164c-0.17969 0.38281-0.45312 0.75781-0.80469 1.1133l-3.7383 3.7891c-0.35156 0.35156-0.76953 0.67578-1.2383 0.95312l-2.2383 1.3242c-0.35156 0.20703-0.37891 0.54688-0.0547 0.61328l2.7383 0.54688c0.17188 0.03125 0.33203 0.07812 0.48438 0.12891l12.48 4.4883c0.14844 0.05469 0.28906 0.11719 0.42188 0.19141l2.0977 1.1953c0.25 0.14062 0.73047-0.03906 0.86719-0.32031",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51.653,-49.244)",
    clipPath: "url(#clip-3)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1210.9 5297.4 9.1797 19.258c1.7969 3.7891 4.5312 7.5781 8.0469 11.094l35.586 36.055c3.4766 3.5156 7.6953 6.7578 12.383 9.5312l23.672 14.023c3.4766 2.1094 3.7891 5.5078 0.5469 6.1328l-32.812 6.5234-124.3 44.688-25.117 14.297c-2.5 1.4062-7.3047-0.3516-8.6719-3.2031l-8.6719-18.164c-1.7969-3.8281-4.5312-7.5781-8.0469-11.133l-37.383-37.891c-3.5156-3.5156-7.6953-6.7578-12.383-9.5312l-22.383-13.242c-3.5156-2.0703-3.7891-5.4688-0.5469-6.1328l27.383-5.4688c1.7188-0.3125 3.3203-0.7812 4.8438-1.2891l124.8-44.883c1.4844-0.5469 2.8906-1.1719 4.2188-1.9141l20.977-11.953c2.5-1.4062 7.3047 0.3906 8.6719 3.2031z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51.653,-49.244)",
    clipPath: "url(#clip-4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m142.8 73.203 0.91797-1.9219c0.18359-0.38281 0.45703-0.75781 0.80469-1.1133l3.5586-3.6016c0.35156-0.35547 0.76953-0.67969 1.2383-0.95703l2.3711-1.4023c0.34766-0.20703 0.37891-0.54688 0.0508-0.61328l-3.2773-0.65234v0.0039l-12.434-4.4688h4e-3l-2.5117-1.4297c-0.25-0.14453-0.73438 0.03516-0.86719 0.32031l-0.86719 1.8164c-0.18359 0.38281-0.45312 0.75781-0.80469 1.1133l-3.7422 3.7852c-0.34766 0.35547-0.76953 0.67969-1.2344 0.95703l-2.2383 1.3242c-0.35156 0.20703-0.38281 0.54688-0.0547 0.61328l2.7383 0.54297c0.16797 0.03516 0.33203 0.07813 0.48047 0.13281l12.48 4.4844c0.15234 0.05469 0.29297 0.12109 0.42188 0.19531l2.0977 1.1914c0.25 0.14453 0.73047-0.03516 0.86719-0.32031",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51.653,-49.244)",
    clipPath: "url(#clip-5)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1428 5221.2 9.1797 19.219c1.8359 3.8281 4.5703 7.5781 8.0469 11.133l35.586 36.016c3.5156 3.5547 7.6953 6.7969 12.383 9.5703l23.711 14.023c3.4766 2.0703 3.7891 5.4688 0.5078 6.1328l-32.773 6.5234v-0.039l-124.34 44.688h0.039l-25.117 14.297c-2.5 1.4453-7.3438-0.3515-8.6719-3.2031l-8.6719-18.164c-1.8359-3.8281-4.5312-7.5781-8.0469-11.133l-37.422-37.852c-3.4766-3.5547-7.6953-6.7969-12.344-9.5703l-22.383-13.242c-3.5156-2.0703-3.8281-5.4688-0.5469-6.1328l27.383-5.4297c1.6797-0.3515 3.3203-0.7812 4.8047-1.3281l124.8-44.844c1.5234-0.5468 2.9297-1.2109 4.2188-1.9531l20.977-11.914c2.5-1.4453 7.3047 0.3516 8.6719 3.2031z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.888 -41.644)",
    clipPath: "url(#clip-3-0)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1210.9 5297.4 9.1797 19.258c1.7969 3.7891 4.5312 7.5781 8.0469 11.094l35.586 36.055c3.4766 3.5156 7.6953 6.7578 12.383 9.5312l23.672 14.023c3.4766 2.1094 3.7891 5.5078 0.5469 6.1328l-32.812 6.5234-124.3 44.688-25.117 14.297c-2.5 1.4062-7.3047-0.3516-8.6719-3.2031l-8.6719-18.164c-1.7969-3.8281-4.5312-7.5781-8.0469-11.133l-37.383-37.891c-3.5156-3.5156-7.6953-6.7578-12.383-9.5312l-22.383-13.242c-3.5156-2.0703-3.7891-5.4688-0.5469-6.1328l27.383-5.4688c1.7188-0.3125 3.3203-0.7812 4.8438-1.2891l124.8-44.883c1.4844-0.5469 2.8906-1.1719 4.2188-1.9141l20.977-11.953c2.5-1.4062 7.3047 0.3906 8.6719 3.2031z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAflatsheet2Pillow);
export default __webpack_public_path__ + "static/media/aflatsheet2pillow.dd4a1b3075027f665411f1d245cbd2ca.svg";
export { ForwardRef as ReactComponent };